/* eslint-disable linebreak-style */
/* eslint-disable quotes */
import React, { useState } from "react";
import PropTypes from "prop-types";
import ContactDetailsMissing from './ContactDetailsMissing';
import { useTranslation } from 'react-i18next';

function StudentsList({
  students,
  onEdit,
  onRemove,
  onAddStudent,
  hideClientIdFallback,
  showContactDetails,
  initialNumToShow,
  onNumToShowChange,
}) {
  const { t: tr } = useTranslation();
  const nameSurnameColClassname = onAddStudent ? "col-4 pt-1" : "col-6";
  const [numToShow, setNumToShow] = useState(initialNumToShow || 25);
  const getClientLabel = student => (
    student.clientDisplayName || student.clientName || (!hideClientIdFallback && student.clientId) || ''
  );

  const updateNumToShow = (nextValue) => {
    setNumToShow(nextValue);
    onNumToShowChange(nextValue);
  };

  const handleShowMore = () => {
    updateNumToShow(numToShow + 25);
  };

  const handleShowAll = () => {
    updateNumToShow(students.length);
  };

  const handleRowKeyDown = (event, student) => {
    if (!onEdit || (event.key !== 'Enter' && event.key !== ' ')) return;
    event.preventDefault();
    onEdit(student);
  };

  return (
    <div>
      <div className="row table-header manage-table-title text-center mx-0">
        {onAddStudent && (
          <button type="button" className="btn btn-link col-2 pr-0" onClick={onAddStudent} aria-label={tr("manage:addStudent_28")}>
            <i className="fas fa-plus fa-lg white-font" />
          </button>
        )}
        <div className={nameSurnameColClassname}>
          <div className="row">
            <div className="col-md-5 pr-0 pr-md-3 table-cell">{tr("manage:firstName_156")}</div>
            <div className="col-md-7 pr-0 pr-md-3 table-cell">{tr("common:lastName")}</div>
          </div>
        </div>
        <div className="col-3 d-flex align-items-center justify-content-center table-cell">{tr("manage:client_108")}</div>
        <div className="col-3 d-flex align-items-center justify-content-center table-cell">{tr("manage:additionalInformation_353")}</div>
      </div>
      <div className="">
        {students.slice(0, numToShow).map((student, index) => (
          <div
            key={student.id}
            className={`table-row row d-flex manage-text text-center mx-0 ${onEdit && "cursor-pointer"} ${index % 2 !== 0 ? "table-row-alternate" : ""}`}
            {...(onEdit ? {
              onClick: () => onEdit(student),
              onKeyDown: event => handleRowKeyDown(event, student),
              role: "button",
              tabIndex: 0,
            } : {})}
          >
            {onRemove && (
              <button type="button" className="btn btn-link col-2 pr-0" onClick={() => onRemove(student)} aria-label={tr("manage:removeStudent_230")}>
                <i className="fas fa-minus fa-lg teal-font" />
              </button>
            )}
            <div className={nameSurnameColClassname}>
              <div className="row d-flex">
                <div className="col-md-5 pr-0 pr-md-3 table-cell">{student.firstName}</div>
                <div className={`col-md-7 pr-0 pr-md-3 table-cell ${showContactDetails ? 'contact-student-name' : ''}`}>
                  <span>{student.lastName}</span>
                  {showContactDetails && <ContactDetailsMissing email={student.email} mobile={student.mobile} />}
                </div>
              </div>
            </div>
            <div className="col-3 d-flex align-items-center justify-content-center table-cell">{getClientLabel(student)}</div>
            <div className="col-3 d-flex align-items-center justify-content-center table-cell">{student.additionalInfo}</div>
          </div>
        ))}
      </div>

      <div className="pt-3 row mx-0 d-flex justify-content-center">
        {numToShow < students.length && (
          <div className="col-md-3 form-group">
            <button type="button" className="btn manage-button manage-red-button btn-block" onClick={handleShowMore}>{tr("manage:showMore_73")}</button>
          </div>
        )}

        {numToShow < students.length && (
          <div className="col-md-3 form-group">
            <button type="button" className="btn manage-button btn-dark btn-block" onClick={handleShowAll}>{tr("manage:showEveryone_157")}</button>
          </div>
        )}
      </div>
    </div>
  );
}

StudentsList.propTypes = {
  showContactDetails: PropTypes.bool,
  students: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      clientId: PropTypes.string,
      clientDisplayName: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      additionalInfo: PropTypes.string,
    }),
  ).isRequired,
  onEdit: PropTypes.func,
  onRemove: PropTypes.func,
  onAddStudent: PropTypes.func,
  hideClientIdFallback: PropTypes.bool,
  initialNumToShow: PropTypes.number,
  onNumToShowChange: PropTypes.func,
};

StudentsList.defaultProps = {
  showContactDetails: false,
  onEdit: null,
  onRemove: null,
  onAddStudent: null,
  hideClientIdFallback: false,
  initialNumToShow: 25,
  onNumToShowChange: () => {},
};

export default StudentsList;
